import { PageHeader, Tag, Popconfirm, Tooltip, message } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItemDinamico, HeaderActions } from '../../../Components/Items'
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import { EyeOutlined, EditOutlined, StopOutlined, FilePdfOutlined, CopyOutlined, ImportOutlined } from "@ant-design/icons";

moment.locale("es");


class Polizas extends Component {
  tableRef = React.createRef();
  state = {
    todasPolizas: [],
    totalRecords: 0,
    loading: false,
    valor: 1,
  }

  consultarPolizas(params) {
    this.setState({ loading: true })
    axios
      .post(
        "polizas/selectTodasPolizas",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasPolizas: res.data.data.map(value => {
              return { ...value, accion: { _id: value._id, estado: value.estado, manual: value.manual } }
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasPolizas: [], loading: false });
        }
      });
  }
  verPoliza(id) {
    this.props.history.push("/panel/verPoliza", { id });
  }
  verPolizasFactura(facturaId) {
    this.props.history.push("/panel/verPolizasFactura", { facturaId });
  }
  agregarPoliza() {
    this.props.history.push("/panel/polizaManual");
  }
  importarPolizas() {
    this.props.history.push("/panel/importarPolizas");
  }
  cancelarPoliza(value) {
    axios
      .post(
        "polizas/cancelarPoliza",
        { polizaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Poliza cancelada");
        } else {
          message.error("Sucedio un eror y no se pudo cancelar");
        }
        this.consultarPolizas(this.state.valor);
      });
  }
  editarPolizaManual(id) {
    this.props.history.push('/panel/editarPolizaManual', { id })
  }
  duplicarPoliza(id) {
    this.props.history.push("/panel/polizaManual", { id });
  }
  render() {
    const columns = [
      {
        title: "IED",
        dataIndex: "tipodepoliza",
        key: "tipodepoliza",
        render: (value) => {
          let ied
          if (value.tipoDePolizaId === 1) ied = 'Ingreso'
          if (value.tipoDePolizaId === 2) ied = 'Egreso'
          if (value.tipoDePolizaId === 3) ied = 'Traslado'
          if (value.tipoDePolizaId === 4) ied = 'Nomina'
          if (value.tipoDePolizaId === 5) ied = 'Pago'
          if (value.tipoDePolizaId === 6) ied = 'Diario'
          return ied
        },
        width: '10%'
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: '25%',
        buscar: "concepto",
      },
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        sorter: true,
        render: (value) => moment(value).locale('es').format('L'),
        width: '15%',
      },
      {
        title: "Numero Poliza",
        dataIndex: "numeroTipoPoliza",
        key: "numeroTipoPoliza",
        width: '10%',
        buscar: "numeroTipoPoliza",
      },
      {
        title: "Numero Poliza",
        dataIndex: "numeroTipoTipoPoliza",
        key: "numeroTipoTipoPoliza",
        width: '10%',
        buscar: "numeroTipoTipoPoliza",
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value) => {
          if (value === 0) {
            return <Tag color='red' className="square-tag">Cancelada</Tag>
          }
          if (value === 1) {
            return <Tag color='blue' className="square-tag">Vigente</Tag>
          }
        },
        width: '13%'
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record) => {
          let buttons = [];

          // Botón Ver
          buttons.push(
            <Tooltip title="Ver Poliza" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`ver-${value._id}`}
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => this.verPoliza(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // Botón Ver Pólizas de esta Factura (solo si la póliza viene de una factura)
          if (record.facturaId) {
            buttons.push(
              <Tooltip title="Ver Pólizas de esta Factura" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`verPolizasFactura-${value._id}`}
                  type="default"
                  size="small"
                  morado
                  icon={<FilePdfOutlined />}
                  onClick={() => this.verPolizasFactura(record.facturaId)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Editar (si es manual, o si el complemento editarTodasLasPolizas está activo, y no está cancelada)
          if ( (value.manual || this.props.editarTodasLasPolizas) && value.estado !== 0 && this.props.permisoCancelarPolizaManualmente) {
            buttons.push(
              <Tooltip title="Editar Poliza" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${value._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarPolizaManual(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Duplicar (crea una nueva poliza precargada con estos datos)
          if (this.props.permisoAgregarPolizaManualmente) {
            buttons.push(
              <Tooltip title="Duplicar Poliza" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`duplicar-${value._id}`}
                  type="default"
                  size="small"
                  lila
                  icon={<CopyOutlined />}
                  onClick={() => this.duplicarPoliza(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Cancelar (solo si es manual y no está cancelada)
          if (value.manual && value.estado !== 0 && this.props.permisoCancelarPolizaManualmente) {
            buttons.push(
              <Popconfirm
                key={`cancelar-${value._id}`}
                title="Seguro que quieres cancelar esta poliza"
                onConfirm={() => this.cancelarPoliza(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Polizas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Vigente', value: 1 }, { label: 'Cancelada', value: 2 }, { label: 'Todos', value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              <HeaderActions>
                {this.props.permisoAgregarPolizaManualmente &&
                  <ButtonItem
                    type="default"
                    key="importarPolizas"
                    icon={<ImportOutlined />}
                    onClick={this.importarPolizas.bind(this)}
                  >
                    Importar Pólizas
                  </ButtonItem>}
              </HeaderActions>
              {this.props.permisoAgregarPolizaManualmente &&
                <ButtonItem
                  type="primary"
                  key="agregarPoliza"
                  olivo
                  onClick={this.agregarPoliza.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Poliza Manualmente
                </ButtonItem>}
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarPolizas.bind(this)}
          size="small"
          dataSource={this.state.todasPolizas}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => this.verPoliza(record._id),
          })}
          filterStorageKey={"polizasFiltrosTabla" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarPolizaManualmente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    permisoCancelarPolizaManualmente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    editarTodasLasPolizas: state.empresa.editarTodasLasPolizas,
  };
};

export default connect(mapStateToProps)(Polizas);